import styled, {css} from 'styled-components';
import { theme } from '../styles/theme';

const HeroContainer = styled.div`
    padding-left: 45px;
    padding-right: 45px;
    padding-top: 45px;
    padding-bottom: 45px;
    max-width: 1170px;
    margin-right: auto;
    margin-left: auto;
    background-color: #fff;
    position: relative;
    @media screen and (max-width: 768px) {
        padding-left: 0px;
        padding-right: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
    }
`

const ImageConatiner = styled.div`
    position: absolute;
    right: 45px;
    left: 45px;
    height: calc(100% - 45px);
    @media screen and (max-width: 768px) {
        position: static;
    }
`

const LargeImg = styled.div`
    width: 70%;
    position: relative;
    margin-left: auto;
    margin-right: 0;
    overflow: hidden;
    z-index: 20;
    @media screen and (max-width: 768px) {
        display: none;
    }
`

const SmallImg = styled.div`
    width: 50%;
    margin-top: 15px;
    position: relative;
    margin-left: auto;
    margin-right: 0;
    overflow: hidden;
    z-index: 20;
    @media screen and (max-width: 768px) {
        width: 100%;
    }
`

const Img = styled.img`
    width: 100%;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
`

const ContentContainer = styled.div`
    position: relative;
    z-index: 100;
`

const Content = styled.div`
    max-width: 540px;
    padding: 50px 40px;
    margin-top: 280px;
    margin-left: 0;
    margin-right: auto;
    background-color: #fff;
    z-index: 30;
    position: relative;
    @media screen and (max-width: 768px) {
        padding: 40px 0px;
        margin-top: 0px;
    }
`


export default function HeroImagesApproved ({alignRight, srcLarge, srcSmall, title, subtitle, children,}) {

    return (
        <HeroContainer>
            <ImageConatiner>
                <LargeImg>
                    <Img src={srcLarge}  />
                </LargeImg>
                <SmallImg>
                    <Img src={srcSmall}  />
                </SmallImg>
            </ImageConatiner>
            <ContentContainer>
                <Content>   
                    <p>{subtitle}</p>
                    <h1>{title}</h1>
                    <div>{children}</div>
                </Content>
            </ContentContainer>
        </HeroContainer>
    )
}